import { useAuth } from "@/auth/AuthContext";
import { Center, Loader } from "@mantine/core";
import React from "react";
import { Navigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }

  // if logged in, it means the user has already used a valid beta key previously. Admit into app.
  if (user) {
    return children;
  }

  // Redirect to login. Deep linking is handled via magic links, not query params.
  return <Navigate to="/" replace />;
};
